import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  partnerLabel: {
    id: `app.containers.WorkflowEditor.components.Rules.Condition.components.PartnerLabelSelect.partnerLabel`,
    defaultMessage: 'Partner Label',
  },
});
